import { Trans, useTranslation } from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { ListItem, ListItemIcon } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';

type Faq = {
  question: string;
  answer: string;
};

const faq: Faq[] = [
  {
    question: 'vsga:faq.question1',
    answer: 'vsga:faq.answer1',
  },
  {
    question: 'vsga:faq.question2',
    answer: 'vsga:faq.answer2',
  },
  {
    question: 'vsga:faq.question3',
    answer: 'vsga:faq.answer3',
  },
  {
    question: 'vsga:faq.question4',
    answer: 'vsga:faq.answer4',
  },
];

export function FAQ() {
  const { t } = useTranslation();

  return (
    <StackStyled maxWidth="600px" width="100%" minHeight="72vH">
      {faq.map((q) => (
        <StackQuestionStyled key={q.question}>
          <Typography // TODO mobile-friendly Typography in ui/legacy and ui/atoms
            variant="body1 medium"
            color="darkBlue"
          >
            {t(q.question)}
          </Typography>
          <StackAnswerStyled>
            <Typography variant="body2 light" color="darkBlue">
              <Trans
                i18nKey={q.answer}
                components={{
                  ul: <ul style={{ padding: 0, margin: 0 }} />,
                  li: (
                    <ListItem
                      noMargin
                      alignItems="flex-start"
                      color="darkBlue"
                      typographyVariant="body2"
                    />
                  ),
                  span: (
                    <ListItemIcon
                      icon="circle-solid"
                      style={{ fontSize: '0.25em', paddingBottom: '2px' }}
                    />
                  ),
                }}
              />
            </Typography>
          </StackAnswerStyled>
        </StackQuestionStyled>
      ))}
    </StackStyled>
  );
}

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 2),
}));

const StackQuestionStyled = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const StackAnswerStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1, 0),
}));
